import { useQuery } from "react-query";
import { getLessonPlans, getLessonPlansDocuments } from "../services/school/lessonPlans/getLessonPlans";
import { PagedRequestType } from "../types/PagedResults";
import { Key_lessonPlanDocuments, Key_lessonPlans } from "../utils/constants";

export const useGetLessonPlansQuery = (data: PagedRequestType, options: any = null ) =>
  useQuery(
    [Key_lessonPlans, JSON.stringify(data)],
    () => getLessonPlans(data),
    options? {...options}:{}
  );
export const useGetLessonPlansDocumentsQuery = (data: PagedRequestType, options: any = null ) =>
  useQuery(
    [Key_lessonPlanDocuments, JSON.stringify(data)],
    () => getLessonPlansDocuments(data),
    options? {...options}:{}
  );